<!-- progress bar starts -->
<div class="alert alert-danger" *ngIf="timeOutError">
       {{timeoutErrorMessage}}
</div>
<div class="background-style">

       <div class="progress ie-padding">
              <div class="circle done"> <span class="label">1</span>
                     <p class="title-span-1">Site</p>

              </div> <span class="bar"><span class=" bar-done "></span></span>

              <div class="circle done"> <span class="label">2</span>
                     <p class="title-span-2">ERG</p>
              </div> <span class="bar"><span class=" bar-done"></span></span>

              <div class="circle done"> <span class="label">3</span>
                     <p class="title-span-3 ie-span-3">Areas of Impact</p>
              </div> <span class="bar"></span>

              <div class="circle"> <span class="label">4</span>
                     <p class="title-span-4">Skills/interests</p>
              </div>
       </div>
       <!-- progress bar ends -->

       <!-- membership interest starts -->
       <div class="div">
              <div class="heading">
                     ERG's are focused on three business impact drivers. Please select interests around Areas of Impact.
                     This information is optional, click on <a class="skip-color" routerLink='../skills'
                            (click)="skipInterest()">skip form</a> if you want to skip.
              </div>
              <div class="container font-family">
                     <div class="row">
                            <aside class="col-md-12 col-lg-4 padding-mid" aria-label="Workforce Inclusion">
                                   <div class="card h-100">
                                          <article class="card-group-item">
                                                 <header class="card-header">
                                                        <label class="master-label">
                                                               <input type="checkbox" name="check"
                                                                      [(ngModel)]="mastercheckbox1"
                                                                      (change)="selectAllWorkforceInclusion($event)">
                                                               <span class="label-master checkbox-style"></span>
                                                               <h6 class="title title-align title-small-screen">
                                                                      WORKFORCE INCLUSION </h6>
                                                        </label>
                                                 </header>
                                                 <div class="filter-content">
                                                        <div class="card-body">
                                                               <form>
                                                                      <label class="col-md-12 interest-display"
                                                                             *ngFor="let interst1 of firstCategory">
                                                                             <input type="checkbox"
                                                                                    [checked]="interst1.checked"
                                                                                    (change)="toggleCheckbox($event,interst1,1)"
                                                                                    name="check"
                                                                                    id="check_{{interst1.areaOfImpactId}}">
                                                                             <span
                                                                                    class="label-text checkbox-style"></span>
                                                                             <label class="bpg-name bold-text"
                                                                                    for="check_{{interst1.areaOfImpactId}}">{{interst1.subCategory}}</label>

                                                                      </label>
                                                               </form>

                                                        </div>
                                                 </div>
                                          </article>
                                   </div>
                            </aside>
                            <aside class="col-md-12 col-lg-4 padding-mid" aria-label="Workplace Engagement">
                                   <div class="card h-100">
                                          <article class="card-group-item">
                                                 <header class="card-header">
                                                        <label class="master-label">
                                                               <input type="checkbox" name="check"
                                                                      [(ngModel)]="mastercheckbox2"
                                                                      (change)="selectAllWorkforceEngagement($event)">
                                                               <span class="label-master checkbox-style"></span>
                                                               <h6 class="title title-align title-small-screen">
                                                                      WORKPLACE ENGAGEMENT </h6>
                                                        </label>
                                                 </header>
                                                 <div class="filter-content ">
                                                        <div class="card-body">
                                                               <form>
                                                                      <label class="col-md-12 interest-display"
                                                                             *ngFor="let interst2 of secondCategory">
                                                                             <input type="checkbox"
                                                                                    [checked]="interst2.checked"
                                                                                    (change)="toggleCheckbox($event,interst2,2)"
                                                                                    name="check"
                                                                                    id="check_{{interst2.areaOfImpactId}}"><span
                                                                                    class="label-text checkbox-style"></span>
                                                                             <label class="bpg-name bold-text"
                                                                                    for="check_{{interst2.areaOfImpactId}}">{{interst2.subCategory}}</label>

                                                                      </label>
                                                               </form>
                                                        </div>
                                                 </div>
                                          </article>
                                   </div>

                            </aside>

                            <aside class="col-md-12 col-lg-4 padding-mid" aria-label="MarketPlace Connection">
                                   <div class="card h-100">
                                          <article class="card-group-item">
                                                 <header class="card-header">
                                                        <label class="master-label">
                                                               <input type="checkbox" name="check"
                                                                      [(ngModel)]="mastercheckbox3"
                                                                      (change)="selectAllMarketplaceConnection($event)">
                                                               <span class="label-master checkbox-style"></span>
                                                               <h6 class="title title-align title-small-screen">
                                                                      MARKETPLACE CONNECTION </h6>
                                                        </label>
                                                 </header>
                                                 <div class="filter-content">
                                                        <div class="card-body">
                                                               <form>
                                                                      <label class="col-md-12 interest-display"
                                                                             *ngFor="let interst3 of thirdCategory">
                                                                             <input type="checkbox"
                                                                                    [checked]="interst3.checked"
                                                                                    (change)="toggleCheckbox($event,interst3,3)"
                                                                                    name="check"
                                                                                    id="check_{{interst3.areaOfImpactId}}"><span
                                                                                    class="label-text checkbox-style"></span>
                                                                             <label class="bpg-name bold-text "
                                                                                    for="check_{{interst3.areaOfImpactId}}">{{interst3.subCategory}}</label>

                                                                      </label>
                                                               </form>
                                                        </div>
                                                 </div>
                                          </article>
                                   </div>

                            </aside>


                     </div>

              </div>
              <p class="top-space text-center padding-mid">

                     <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button"
                            routerLink='../bpg' (click)="redirectToBpg()">BACK</button>
                     <button type="button" class="btn btn-danger col-sm-2 col-md-2 font-family-button"
                            routerLink='../skills' (click)="saveData()">NEXT</button>
                     <button type="button" class="btn btn-link  font-family button-position" routerLink='../skills'
                            (click)="skipInterest()"> Skip Form ></button>

              </p>

       </div>
</div>
<!-- membership interest ends -->
